import React from "react"
import {Card, FormGroup, Switch} from "@blueprintjs/core"
import {useDispatch, useSelector} from "react-redux"
import ActionButton from "../../../core/components/buttons/ActionButton"
import ExportFileTypeSelect from "./ExportFileTypeSelect"
import handleBooleanChange from "../../../core/utils/handleChangehelpers"
import {
    getGenerateTable,
    getRefDbDataContext,
    isExporting,
} from "../../redux/refdb.selector"
import {setDisplayDataContextAction} from "../../redux/refdb.actions"
import InternOnly from "../../../core/components/InternOnly"
import GenerateTableType from "../../../shared/enums/generateTableType"

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ExportOptionsCardProps {
    exportDisplayData: any
}

const ExportOptionsCard: React.FC<ExportOptionsCardProps> = (props) => {
    const contextData = useSelector(getRefDbDataContext)
    const isExportingDate = useSelector(isExporting)
    const tableType = useSelector(getGenerateTable)
    const dispatch = useDispatch()
    const {exportDisplayData} = props
    const setExportFileType = (selected: any) => {
        const newContext = {...contextData, exportFileType: selected}
        dispatch(setDisplayDataContextAction(newContext))
    }

    const setLog2Transformation = (e: any) => {
        const newContext = {...contextData, log2Transformation: e}
        dispatch(setDisplayDataContextAction(newContext))
    }

    const setIncludesSummary = (e: any) => {
        const newContext = {...contextData, includesSummary: e}
        dispatch(setDisplayDataContextAction(newContext))
    }

    const setCategorizeDetectability = (e: any) => {
        const newContext = {...contextData, categorizeDetectability: e}
        dispatch(setDisplayDataContextAction(newContext))
    }
    const setSumUpMetaboliteClasses = (e: any) => {
        const newContext = {...contextData, sumUpMetaboliteClasses: e}
        dispatch(setDisplayDataContextAction(newContext))
    }

    return (
        <Card>
            <FormGroup
                inline
                label="File type"
                labelFor="export-file-type-select"
            >
                <ExportFileTypeSelect
                    id="export-file-type-select"
                    selectedValue={contextData.exportFileType}
                    setSelectedValue={setExportFileType}
                />
            </FormGroup>
            <div>
                <Switch
                    checked={contextData.includesSummary}
                    labelElement="Include summary of selected options"
                    onChange={handleBooleanChange((value) =>
                        setIncludesSummary(value)
                    )}
                />
            </div>
            <div>
                <Switch
                    checked={contextData.log2Transformation}
                    labelElement="log2 transformation"
                    disabled={
                        tableType === GenerateTableType.demographic ||
                        tableType === GenerateTableType.detectabilitySummary
                    }
                    onChange={handleBooleanChange((value) =>
                        setLog2Transformation(value)
                    )}
                />
            </div>
            <InternOnly>
                <div id="categorizeDetectability">
                    <Switch
                        checked={contextData.categorizeDetectability}
                        disabled={
                            tableType !== GenerateTableType.detectabilitySummary
                        }
                        labelElement="Categorize detectability"
                        onChange={handleBooleanChange((value) =>
                            setCategorizeDetectability(value)
                        )}
                    />
                </div>
            </InternOnly>
            <InternOnly>
                <div id="categorizeDetectability">
                    <Switch
                        checked={contextData.sumUpMetaboliteClasses}
                        disabled={
                            tableType !== GenerateTableType.detectabilitySummary
                        }
                        labelElement="Sum up metabolite classes"
                        onChange={handleBooleanChange((value) =>
                            setSumUpMetaboliteClasses(value)
                        )}
                    />
                </div>
            </InternOnly>
            <div className="CardRow">
                <ActionButton
                    className="CardRowElement"
                    text="Export"
                    onClick={exportDisplayData}
                    disabled={isExportingDate}
                />
            </div>
        </Card>
    )
}

export default ExportOptionsCard
